module.exports = __webpack_public_path__ + "media/images/facilities/whiteboard-4c0286abf01337405e79ae2c72288eed.png";